"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InvitationsModel = /** @class */ (function () {
    function InvitationsModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/invitations",
            UPDATE: APPURL + "/api/v1/invitations",
            CREATE: APPURL + "/api/v1/invitations",
            INSTRUCTOR: APPURL + "/api/v1/instructor-invitations",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    InvitationsModel.prototype.extract = function (result) {
        return result.data;
    };
    InvitationsModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    InvitationsModel.prototype.getInvitationByID = function (id) {
        return this.$http.get(this.URLS.FETCH + "/" + id).then(this.cacheResults);
    };
    InvitationsModel.prototype.get = function () {
        return this.$http.get(this.URLS.FETCH).then(this.cacheResults);
    };
    InvitationsModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    InvitationsModel.prototype.sendInvitation = function (request) {
        return this.$http.post(this.URLS.FETCH, request).then(this.cacheResults);
    };
    InvitationsModel.prototype.destroy = function (invitation) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + invitation.id)
            .then(this.cacheResults);
    };
    InvitationsModel.prototype.getInstructorInvitations = function () {
        return this.$http.get(this.URLS.INSTRUCTOR).then(this.cacheResults);
    };
    InvitationsModel.prototype.sendInstructorInvitation = function (request) {
        return this.$http
            .post(this.URLS.INSTRUCTOR, request)
            .then(this.cacheResults);
    };
    InvitationsModel.prototype.revokeInstructorInvitation = function (id) {
        return this.$http
            .delete(this.URLS.INSTRUCTOR + "/" + id)
            .then(this.cacheResults);
    };
    InvitationsModel.prototype.resendInstructorInvitation = function (id) {
        return this.$http
            .post(this.URLS.INSTRUCTOR + "/" + id + "/resend", {})
            .then(this.cacheResults);
    };
    return InvitationsModel;
}());
InvitationsModel.$inject = ["$http", "APPURL"];
exports.default = InvitationsModel;
